import axios, { AxiosResponse } from 'axios';
import { ApiCommonParams } from '../models/app';

export const forgot = async ({
  email,
  token,
  lang,
  country
}: ApiCommonParams & { email: string }): Promise<any> => {
  const url = `${process.env.NEXT_PUBLIC_WP_API_URL}/v1/user/forgot-password`;

  const body = new FormData();
  body.append('email', email);

  const config = {
    headers: {
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country,
      ['UYN-BEARER']: token
    }
  };

  await axios.post(url, body, config);
};

export const reset = async ({
  reset_key,
  password,
  email,
  token,
  lang,
  country
}: ApiCommonParams & {
  email: string;
  reset_key: string;
  password: string;
}): Promise<any> => {
  const url = `${process.env.NEXT_PUBLIC_WP_API_URL}/v1/user/reset-password`;

  const body = new FormData();
  body.append('email', email);
  body.append('reset_key', reset_key);
  body.append('password', password);

  const config = {
    headers: {
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country,
      ['UYN-BEARER']: token
    }
  };

  await axios.post(url, body, config);
};
